module.exports = __webpack_public_path__ + "static/media/dagger-rare.851a8ac4.png";